<template>
  <section class="page users">
    <users-panel />
    <users-list
      v-if="users && ($route.name === 'friends' || $route.name === 'users') && !loader"
      :users="users"
      :loader="loader"
    />
    <offers-list
      v-if="users && ($route.name === 'myoffers' || $route.name === 'offers') && !loader"
      :users="users"
      :category="$route.name"
    />
    <pseudo-users v-if="loader && ($route.name === 'friends' || $route.name === 'users')" />
    <pseudo-offers v-if="loader && ($route.name === 'myoffers' || $route.name === 'offers')" />
  </section>
</template>

<script>
import UsersPanel from "@/components/Users/UsersPanel";
import UsersList from "@/components/Users/UsersList";
import OffersList from "@/components/Users/OffersList";
import PseudoOffers from "@/components/Users/PseudoOffers";
import PseudoUsers from "@/components/Users/PseudoUsers";

export default {
  name: "users",
  components: {
    UsersPanel,
    UsersList,
    OffersList,
    PseudoUsers,
    PseudoOffers
  },
  data() {
    return {
      events: [],
      search: null,
      users: null,
      invited: [],
      friends: false,
      loader: true,
      from: false,
      page: 0
    };
  },
  computed: {
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    getAuthUser() {
      return this.$store.getters.getAuthUser;
    },
    getUsersSearch() {
      return this.$store.getters.getUsersSearch;
    }
  },
  methods: {
    async loadData(from) {
      from === 'next' ? '' : (this.page = 0, this.loader = true)
      let params = {
        sports: this.getActiveSports,
        search: this.getUsersSearch,
        type: this.$route.name,
        user: this.getAuthUser.id,
        page: this.page,
        friendship: true,
        offers: true,
        token: localStorage.getItem('token')
      };
      let type = "getUsers";
      this.$route.name === 'friends' ? type = "getFriends" : ''
      this.$route.name === 'offers' ? type = "getOffers" : ''
      this.$route.name === 'myoffers' ? type = "getMyOffers" : ''
      if (from === 'next') {
        let users = await this.$store.dispatch(type, params);
        if (users && users.users) {
            users.users.forEach(user => {
              this.users.users.push(user)
            });
        }
      } else {
        this.users = await this.$store.dispatch(type, params);
      }
      this.loader = false;
    },
    lazyLoad() {
        let timeline = document.querySelector('.users');
        timeline.addEventListener('scroll', () => {
          if (timeline.scrollTop + timeline.clientHeight >= timeline.scrollHeight) {
            this.page++;
            this.loadData('next')
          } 
        })
      }
  },
  watch: {
    $route() {
      this.loadData();
    },
    getAuthUser(user) {
      user ? this.loadData() : "";
    },
    getUsersSearch() {
      this.loadData();
    },
    getActiveSports() {
      this.loadData()
    }
  },
  created() {
    this.getAuthUser ? this.loadData() : '';
    // setInterval(async () => {
    //   this.loadData("loop");
    // }, 2 * 60 * 1000);
  },
  mounted() {
      this.lazyLoad()
    }
};
</script>
